import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

const controllerUrl = `${apiUrl}planograms`;

export const requestPlanogramList = () =>
    axios.get(`${controllerUrl}`);

export const requestPlanogramCopyById = (planogramId) =>
    axios.post(`${controllerUrl}/${planogramId}/copy`);

export const requestPlanogramGetById = (planogramId) =>
    axios.get(`${controllerUrl}/${planogramId}`);

export const requestPlanogramDeleteById = (planogramId) =>
    axios.delete(`${controllerUrl}/${planogramId}`);

export const requestPlanogramDataImport = (planogramId, autoPopulate, data) => {
    const formData = new FormData();
    formData.append("file", data);

    return axios.post(`${controllerUrl}/${planogramId}/data/import?autoPopulate=${autoPopulate}`,
        formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
};

export const requestPlanogramCreate = (data) =>
    axios.post(`${controllerUrl}`, data);

export const requestPlanogramUpdate = (planogramId, data) =>
    axios.put(`${controllerUrl}/${planogramId}`, data);

export const requestPlanogramGetLayoutById = (planogramId, pageNumber, pageSize) =>
    axios.get(`${controllerUrl}/${planogramId}/layout?pageNumber=${pageNumber}&pageSize=${pageSize}`);

export const requestPlanogramCreateLayoutById = (planogramId, data) =>
    axios.post(`${controllerUrl}/${planogramId}/layout`, data);

export const requestPlanogramGetDataListById = (planogramId) =>
    axios.get(`${controllerUrl}/${planogramId}/data`);

export const requestPlanogramCreateData = (planogramId, data) =>
    axios.post(`${controllerUrl}/${planogramId}/data`, data);

export const requestPlanogramGetDataByDataId = (planogramId, dataId) =>
    axios.get(`${controllerUrl}/${planogramId}/data/${dataId}`);

export const requestPlanogramUpdateDataByDataId = (planogramId, dataId, data) =>
    axios.put(`${controllerUrl}/${planogramId}/data/${dataId}`, data);

export const requestPlanogramDeleteDataByDataId = (planogramId, dataId) =>
    axios.delete(`${controllerUrl}/${planogramId}/data/${dataId}`);

export const requestGetCategories = () =>
    axios.get(`${apiUrl}systemLists/PLNCAT/items`);

export const requestGetEntryTypes = () =>
    axios.get(`${apiUrl}systemLists/PLNTYP/items`);
